import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { ActivatedRoute, Router } from '@angular/router';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { ComboParticipanteReuniao } from 'src/app/core/combo-participante-reuniao';
import { Reuniao } from 'src/app/core/reuniao';
import { ReuniaoService } from 'src/app/services/reuniao/reuniao.service';
import { ComboPessoaFisica } from '../../core/combo-pessoa-fisica';
import { DataUtilService } from '../../services/commons/data-util.service';
import { ConfirmDialogComponent } from '../common/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-reuniao',
  templateUrl: './reuniao.component.html',
  styleUrls: ['./reuniao.component.css']
})
export class ReuniaoComponent implements OnInit {

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  reunioes: Reuniao[];
  reuniao: Reuniao = new Reuniao();
  participanteSelecionado: ComboParticipanteReuniao = new ComboParticipanteReuniao();
  relatorSelecionado: ComboPessoaFisica = new ComboPessoaFisica();
  temaSelecionado: string;
  localSelecionado: string;
  dataInicioVigencia: Date;
  dataFimVigencia: Date;

  msg:string;

  mostrarTabela = false;

  displayedColumns: string[] = [
    'tema', 'local', 'relator', 
    'dataInicio', 'participantes', 
    'acoes'
  ];
  dataSource: MatTableDataSource<Reuniao> = new MatTableDataSource();

  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();

  menu: string;
  area: string;
  constructor(
    private reuniaoService: ReuniaoService,
    private router: Router,
    private dialog: MatDialog,
    private activatedRoute:ActivatedRoute, 
    private dataUtilService: DataUtilService
  ) { }

  ngOnInit() {
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);
    this.dataSource.paginator = this.paginator;
    this.area = this.getArea();
    this.getAll();
  }

  getMenu(): string {
    const primeiroSegmento = this.router.url.split('/')[1];
    return primeiroSegmento.startsWith('menu') ? primeiroSegmento : undefined;
  }

  private getArea(): string {
    this.menu = this.getMenu();
    return this.menu && this.menu == "menu-sap" ? 'S' : (this.menu && this.menu == "menu-pedagogico" ? 'P' : null);
  }

  limpar() {
    this.mostrarTabela = false;
    this.reuniao = new Reuniao();
    this.dataSource.data = [];
    this.localSelecionado = undefined;
    this.temaSelecionado = undefined;
    this.dataInicioVigencia = undefined;
    this.dataFimVigencia = undefined;
    this.participanteSelecionado = new ComboParticipanteReuniao();
    this.relatorSelecionado = new ComboPessoaFisica();
  }

  consultar() {
    if (
        (this.participanteSelecionado && this.participanteSelecionado.nome) ||
        (this.relatorSelecionado && this.relatorSelecionado.nome) ||
        this.dataInicioVigencia ||
        this.dataFimVigencia ||
        this.localSelecionado ||
        this.temaSelecionado
    ) {
        this.reuniaoService
            .getFilter(
                this.participanteSelecionado?.nome,
                this.relatorSelecionado?.nome,
                this.dataInicioVigencia?.getTime(),
                this.dataFimVigencia?.getTime(),
                this.localSelecionado,
                this.temaSelecionado,
                this.area
            )
            .subscribe((reunioes: Reuniao[]) => {
                if (!reunioes) {
                    this.mostrarTabela = false;
                    this.msg = "Nenhum registro para a pesquisa selecionada";
                } else {
                    this.dataSource.data = reunioes ? reunioes : [];
                    this.mostrarTabela = true;
                }
            });
    } else {
        this.getAll();
    }
  }

  atualizar(reuniao: Reuniao) {
    reuniao.area = this.area;
    const rota = this.menu ? this.menu+'/reunioes/cadastrar':'reunioes/cadastrar';
    this.router.navigate([rota], { queryParams: { idReuniao: reuniao.id } });
  }

  deletar(reuniao: Reuniao) {
    this.chamaCaixaDialogo(reuniao);
  }

  chamaCaixaDialogo(reuniao: Reuniao) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      pergunta: `Certeza que deseja excluir a reuniao ${reuniao.tema}?`,
      textoConfirma: 'SIM',
      textoCancela: 'NÃO'
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirma => {
      if (confirma) {
        this.reuniaoService.excluir(reuniao.id).subscribe(() => {
          this.reuniao.id = null;
          this.consultar();
        })
      } else {
        dialogRef.close();
      }
    }
    );
  }

  getAll() {
    this.reuniaoService.getAllIntituicaoLogada(this.area).subscribe((reunioes: Reuniao[]) => {
      this.reunioes = reunioes;
      this.dataSource.data = reunioes ? reunioes : [];
      this.verificaMostrarTabela(reunioes);
    })
  }
  verificaMostrarTabela(reunioes: Reuniao[]) {
    if(!reunioes ||reunioes.length == 0) {
      this.mostrarTabela = false; 
      this.msg = "Nenhuma reuniao cadastrada."
    }else{
      this.mostrarTabela = true; 
    }
  }
  
  onTemaChangeReuniao(registro: Reuniao) {
    this.temaSelecionado = registro.tema;
  }

  onLocalChangeReuniao(registro: Reuniao) {
    this.localSelecionado = registro.local;
  }

  onNomeParticipanteChangeReuniao(registro: ComboParticipanteReuniao) {
    this.participanteSelecionado = registro;
  }

  onNomeChangeRelatorReuniao(registro: ComboPessoaFisica) {
    this.relatorSelecionado = registro;
  }

  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }
}
